import type { AssessmentQuestion } from '@ts-assessment/interfaces'

import imgQuestion5 from '@images/assessment/questions/math/grade-k8/question-5.png'
import imgQuestion6 from '@images/assessment/questions/math/grade-k8/question-6.png'
import imgQuestion7 from '@images/assessment/questions/math/grade-k8/question-7.png'
import imgQuestion10 from '@images/assessment/questions/math/grade-k8/question-10.png'

export const questions: AssessmentQuestion[] = [
  {
    name: 'grade_k8_1',
    title: 'Which value of x is x³ = 2744?',
    topic: 'Exponent Notation',
    answers: [
      {
        name: 'grade_k8_1_a',
        text: '8',
      },
      {
        name: 'grade_k8_1_b',
        text: '16',
      },
      {
        name: 'grade_k8_1_c',
        text: '9',
      },
      {
        name: 'grade_k8_1_d',
        text: '14',
        correct: true,
      },
    ],
  },
  {
    name: 'grade_k8_2',
    title: 'Simplify 5.2 × 10⁴- 3.9 × 10⁴.',
    topic: 'Scientific Notation',
    answers: [
      {
        name: 'grade_k8_2_a',
        text: '1300',
      },
      {
        name: 'grade_k8_2_b',
        text: '130000',
      },
      {
        name: 'grade_k8_2_c',
        text: '130',
      },
      {
        name: 'grade_k8_2_d',
        text: '13000',
        correct: true,
      },
    ],
  },
  {
    name: 'grade_k8_3',
    title: 'Calculate the answer of 89.7 ÷ 10⁵.',
    topic: 'Scientific Notation',
    answers: [
      {
        name: 'grade_k8_3_a',
        text: '0.000897',
        correct: true,
      },
      {
        name: 'grade_k8_3_b',
        text: '0.0897',
      },
      {
        name: 'grade_k8_3_c',
        text: '0.897',
      },
      {
        name: 'grade_k8_3_d',
        text: '0.00897',
      },
    ],
  },
  {
    name: 'grade_k8_4',
    title: 'If 3 = 4(x - 2) + 5 - 3x, calculate x=?',
    topic: 'Linear Equation',
    answers: [
      {
        name: 'grade_k8_4_a',
        text: '2',
      },
      {
        name: 'grade_k8_4_b',
        text: '6',
        correct: true,
      },
      {
        name: 'grade_k8_4_c',
        text: '4',
      },
      {
        name: 'grade_k8_4_d',
        text: '5',
      },
    ],
  },
  {
    name: 'grade_k8_5',
    title: 'Follow the figure and calculate the area of the 1-inch white border',
    topic: 'Function from Geometry',
    image: imgQuestion5,
    answers: [
      {
        name: 'grade_k8_5_a',
        text: '30 inches²',
      },
      {
        name: 'grade_k8_5_b',
        text: '75 inches²',
      },
      {
        name: 'grade_k8_5_c',
        text: '56 inches²',
        correct: true,
      },
      {
        name: 'grade_k8_5_d',
        text: '13 inches²',
      },
    ],
  },
  {
    name: 'grade_k8_6',
    title: 'F\'G\'H\'J\' is the reflection of FGHJ. Look at the figure below and find out the two sides of equal length.\n',
    topic: 'Congruence',
    image: imgQuestion6,
    answers: [
      {
        name: 'grade_k8_6_a',
        text: 'JF and H\'J\'',
      },
      {
        name: 'grade_k8_6_b',
        text: 'FG and F\'J\'',
      },
      {
        name: 'grade_k8_6_c',
        text: 'HG and H\'J\'',
      },
      {
        name: 'grade_k8_6_d',
        text: 'H\'G\' and HG',
        correct: true,
      },
    ],
  },
  {
    name: 'grade_k8_7',
    title: 'If the proportion of PS/PY = 3/4 and P/Y = 20, then find out the corresponding length of the altitude PS by following the given figure.',
    topic: 'Similarity',
    image: imgQuestion7,
    answers: [
      {
        name: 'grade_k8_7_a',
        text: '20 cm',
      },
      {
        name: 'grade_k8_7_b',
        text: '15 cm',
        correct: true,
      },
      {
        name: 'grade_k8_7_c',
        text: '25 cm',
      },
      {
        name: 'grade_k8_7_d',
        text: '36 cm',
      },
    ],
  },
  {
    name: 'grade_k8_8',
    title: 'Ellie bakes different items for online delivery. The rider charges $10 per day plus a commission of $0.5 per item. Find out the suitable linear function that shows the rider’s salary if the salary is ‘y’.',
    topic: 'Linear Function',
    answers: [
      {
        name: 'grade_k8_8_a',
        text: 'y = 0.5',
      },
      {
        name: 'grade_k8_8_b',
        text: 'y = 0.5x + 10',
        correct: true,
      },
      {
        name: 'grade_k8_8_c',
        text: 'y = 10',
      },
      {
        name: 'grade_k8_8_d',
        text: 'y = 0.5 - 10',
      },
    ],
  },
  {
    name: 'grade_k8_9',
    title: 'Flora is 3 times older than Mike. Joe is 7 years older than Flora. If Mike is 5 years old, how old is Joe?',
    topic: 'Linear Function',
    answers: [
      {
        name: 'grade_k8_9_a',
        text: '22 years old',
        correct: true,
      },
      {
        name: 'grade_k8_9_b',
        text: '20 years old',
      },
      {
        name: 'grade_k8_9_c',
        text: '15 years old',
      },
      {
        name: 'grade_k8_9_d',
        text: '10 years old',
      },
    ],
  },
  {
    name: 'grade_k8_10',
    title: 'Follow the given figure and calculate the volume of the popcorn container.',
    topic: 'Introduction to Irrational Numbers Using Geometry',
    image: imgQuestion10,
    answers: [
      {
        name: 'grade_k8_10_a',
        text: '41.7 cubic inches',
        correct: true,
      },
      {
        name: 'grade_k8_10_b',
        text: '35 cubic inches',
      },
      {
        name: 'grade_k8_10_c',
        text: '49 cubic inches',
      },
      {
        name: 'grade_k8_10_d',
        text: '23 cubic inches',
      },
    ],
  },
]
